import styled from "styled-components"

export const SubpageContainer = styled.div`
    background-color: #ffffff;
    border-radius: 16px;
    border: 1px solid #e9ecef;
    box-shadow: 0px 2px 12px -4px rgba(0, 0, 0, 0.12);

    display: flex;
    flex-direction: column;
    gap: 1rem;

    width: 100%;
    max-width: 45rem;
    margin: 1.5rem auto 0 auto;

    padding: 1.5rem;
    @media (min-width: 768px) {
        padding: 2rem;
    }
`
